import { InjectionToken } from '@angular/core';

export const IS_MULTI_TENANT = new InjectionToken<boolean>(
  'Is Multi Tenant environment',
  {
    providedIn: 'root',
    factory: () => true
  }
);
export const KEEP_ALIVE_INTERVAL = new InjectionToken<number>(
  'Maximum duration without communication with the server, to allow refresh token rotation',
  { providedIn: 'root', factory: () => 5 }
);
export const APP_VERSION = new InjectionToken<string>('Application version');
export const ALLOW_SELF_REGISTRATION = new InjectionToken<boolean>(
  'Allow Self Registration'
);
